import * as React from 'react';

const { useState } = React;

export function useForceUpdate() {
  const [value, setValue] = useState(false);

  return () => setValue(!value);
}
